import { Dropdown, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IoIosLogOut } from "react-icons/io";
import { AiOutlineUser } from "react-icons/ai";
import SessionUtil from '../util/SessionUtil';
import Func from '../function/Func';

function UserComp() {
    const { t } = useTranslation();
    const user = SessionUtil.getUser();
    const handleClick = () => {
        SessionUtil.logout();
    }
    return (
        <Dropdown className='filter border-0' align={{ xs: "start" }} >
            <Dropdown.Toggle className='border-0'>
                <Nav.Link className="position-relative">
                    <span className="get-initials dim-30 font-12 text-uppercase">{Func.getInitials(user.FirstName + ' ' + user.LastName)}</span>

                    {/* <LiaUserCircleSolid size={'24'} className='icon-color-grey' /> */}
                    <span className='active-success'></span>
                    </Nav.Link>
            </Dropdown.Toggle>
            <Dropdown.Menu className='border-0 shadow-lg p-2'>
                <Dropdown.Item href='/profile' className="flex-gap-2 font-13"><AiOutlineUser />{user.FirstName + ' ' + user.LastName}</Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item className="flex-gap-2 font-13" onClick={handleClick}><IoIosLogOut />{t('Logout')}</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default UserComp;